import { ServiceLevelBody } from "../../../../../../service/levelService/body";
import { FormInputs, FormTime } from "../types";

export const formatBodyToCreateOrEdit = ({ formTime, formInputs, oldCategories }: { formTime: FormTime; formInputs: FormInputs; oldCategories?: string[] }): ServiceLevelBody => {
    const sectionFormated: string[] = formInputs.section.map(section => section.value) || []
    return {
        areaId: formInputs.areas?.value,
        departmentId: formInputs.departments?.value,
        name: formInputs.register?.trim(),
        description: formInputs.description?.trim(),
        ...!oldCategories && {
            catalogIds: sectionFormated,
        },
        ...!!oldCategories && {
            newCatalogIds: sectionFormated.filter(category => !oldCategories.some(old => old == category)) || [],
            deleteCatalogIds: oldCategories?.filter(old => !sectionFormated?.some(category => category == old)) || [],
        },
        configTimeOla: !!formTime.ola_switch_firstResponseHours,
        configTimeSla: !!formTime.sla_switch_firstResponseHours,
        automaticClosing: !!formTime?.maxtime,
        timeClosing: formTime.maxtimehour?.value ?? 24,
        timesOLA: formTime.ola.map(ola => ({
            id: ola.id,
            days: ola.days,
            hours: ola.hours,
            minutes: ola.minutes,
            seconds: ola.seconds,
            priorityId: ola.priorityId,
        })),
        timesSLA: formTime.sla.map(sla => ({
            id: sla.id,
            days: sla.days,
            hours: sla.hours,
            minutes: sla.minutes,
            seconds: sla.seconds,
            priorityId: sla.priorityId,
        })),
    }
}